import { Heading, Link, Spacer, useToast, VStack } from '@chakra-ui/react';
import { useLoginMutation } from '@partiu/api/auth/hooks';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { LuMoveRight } from 'react-icons/lu';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../../../../packages/ui/components/atoms/Button';
import { Input } from '../../../../../../packages/ui/components/atoms/Input';
import { ShowPasswordToggle } from '../../../../../../packages/ui/components/atoms/ShowPasswordToggle';
import { SectionTitle } from '../../../../../../packages/ui/components/atoms/Title';
import { UsernameInput } from '../../../../../../packages/ui/components/molecules/UsernameInput';
import { useProfile } from '../../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../../packages/ui/contexts/ThemeProvider';

export function LoginForm({ isNative, setExClient }: { isNative: boolean; setExClient?: (value: boolean) => void }) {
  const navigate = useNavigate();
  const toast = useToast({ isClosable: true });
  const { name, id, integratedLogin, idp, colors, exClientModule, reloadTheme } = useTheme();
  const { updateProfile } = useProfile();
  const [showPassword, setShowPassword] = useState(false);
  const { register, handleSubmit } = useForm();

  const loginMutation = useLoginMutation({
    integratedLogin: isNative ? integratedLogin : '',
    onSuccess() {
      updateProfile({});
      reloadTheme();
      navigate('/');
    },
    onError(error) {
      toast({ title: 'Oops!', description: error, status: 'error' });
    },
  });

  return (
    <VStack w={'100%'} align={'flex-start'} spacing={2}>
      <SectionTitle fontSize={14} fontWeight={600}></SectionTitle>
      <Heading
        paddingTop={'20px'}
        paddingBottom={'10px'}
        fontWeight={500}
        letterSpacing={'-0.2rem'}
        fontFamily={'Montserrat'}
        fontSize={'38px'}
      >
        Login
      </Heading>
      <form
        onSubmit={handleSubmit(({ username, password }) => loginMutation.mutate({ username, password, idp }))}
        style={{ width: '100%' }}
      >
        <VStack w={'100%'} spacing={7}>
          <UsernameInput {...register('username')} autoComplete="username" noOptions={isNative} />
          <Input
            label="Senha"
            {...register('password')}
            type={showPassword ? 'text' : 'password'}
            autoComplete="current-password"
            rightElement={<ShowPasswordToggle value={showPassword} onChange={setShowPassword} />}
          />
          {isNative ? (
            <Heading
              alignSelf={'flex-end'}
              cursor={'pointer'}
              onClick={() => {
                if (toast.isActive('password-recovery')) return;

                toast({
                  id: 'password-recovery',
                  title: 'Recuperação de Senha',
                  description: `Para recuperar a senha da sua conta entre em contato com a ${name}.`,
                });
              }}
              textDecor={'underline'}
              fontWeight={500}
              fontSize={'14px'}
              marginTop={'-20px'}
            >
              Esqueci minha senha
            </Heading>
          ) : (
            <Link
              alignSelf={'flex-end'}
              marginTop={'-20px'}
              target="_blank"
              href={`https://api.edge.partiu.com.br/password_reset/?agreement_id=${id}`}
            >
              <Heading textDecor={'underline'} fontWeight={500} fontSize={'14px'}>
                Esqueci minha senha
              </Heading>
            </Link>
          )}

          <Button type="submit" isLoading={loginMutation.isLoading} rightIcon={<LuMoveRight fontSize={'24px'} />}>
            Entrar
          </Button>

          {exClientModule && setExClient && (
            <Button
              backgroundColor="transparent"
              borderColor={colors.primaryColor}
              borderWidth={1}
              color={colors.primaryColor}
              _hover={{ backgroundColor: colors.primaryColor, color: 'white' }}
              onClick={() => setExClient && setExClient(true)}
              isLoading={loginMutation.isLoading}
            >
              Entrar como Ex-Cliente
            </Button>
          )}
        </VStack>
      </form>
      <Spacer />
    </VStack>
  );
}
